import React from 'react';
import { Outlet } from 'react-router-dom';
import { Toaster } from "../components/ui/sonner";
import { AlertProvider } from "@/components/ui/MacOSAlert";

/**
 * LessonLayout provides a clean layout specifically for course lessons
 * with Udemy-style minimalist design.
 */
const LessonLayout: React.FC = () => {
  return (
    <AlertProvider>
      <div className="min-h-screen bg-white">
        {/* No global navbar or styling - the lesson component handles its own header */}
        <main className="w-full">
          <Outlet />
        </main>

        {/* Toast notifications */}
        <Toaster />
        
        {/* Layout debug overlay */}
        {process.env.NODE_ENV !== 'production' && (
          <div
            style={{
              position: "fixed",
              bottom: "10px",
              left: "10px",
              background: "rgba(0,0,0,0.8)",
              color: "white",
              padding: "8px 12px",
              borderRadius: "4px",
              zIndex: 9999,
              fontSize: "12px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
              border: "1px solid rgba(255,255,255,0.2)",
            }}
          >
            <div
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                backgroundColor: "#a435f0", // Udemy purple
              }}
            ></div>
            <div>
              <span style={{ fontWeight: "bold" }}>LessonLayout Active</span>
              <span> • Udemy Style</span>
            </div>
          </div>
        )}
      </div>
    </AlertProvider>
  );
};

export default LessonLayout;
